import React from 'react';
import { withFormsy } from 'formsy-react';
import { InputLabel, TextField, FormHelperText } from '@mui/material';
import ImagePreviewModal from 'components/ImagePreviewModal';
import ActiveStorageProvider from 'react-activestorage-provider';

export class FileInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fileError: null,
      fileUrl: null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(response) {
    const { name, onFileChange, setValue } = this.props;

    if (response.success) {
      onFileChange(name, response.filename);
      this.setState({fileUrl: response.url, fileError: null});
      setValue(response.key);
    } else {
      this.setState({fileError: response.error, fileUrl: null});
      setValue('');
    }
  }

  render() {
    const { type, name, label, required, filename, inputLabelProps, hint, previewImage, errorMessage, isPristine } = this.props;
    const fileErrorMessage = this.state.fileError || errorMessage;
    const isError = !isPristine && fileErrorMessage != null;

    return (
      <div className="input-container">
        <ActiveStorageProvider
          endpoint={{
            path: '/api/v1/file_uploads',
            model: 'FileUpload',
            attribute: 'signed_id',
            method: 'POST'
          }}
          onSubmit={this.handleSubmit}
          render={({ handleUpload, uploads, ready }) => (
            <div>
              <InputLabel htmlFor={name} className="file-label" error={isError} required={required}>{label}</InputLabel>
              <TextField
                type={type}
                disabled={!ready}
                id={name}
                name={name}
                aria-label={label}
                onChange={e => handleUpload(e.currentTarget.files)}
                error={isError}
                fullWidth
              />

              <span aria-live="polite">
                {!isPristine && fileErrorMessage &&
                  <FormHelperText error={isError}>{fileErrorMessage}</FormHelperText>
                }
              </span>
              {!isPristine && uploads[0] && uploads[0].state == 'error' &&
                <FormHelperText error={isError}>{uploads[0].error}</FormHelperText>
              }
              {hint &&
                <FormHelperText>{hint}</FormHelperText>
              }
              {previewImage && this.state.fileUrl &&
                <ImagePreviewModal title={`View Uploaded Image - ${label}`} buttonLabel="View Uploaded Image" image={this.state.fileUrl} />
              }
            </div>
          )}
        />
      </div>
    );
  }
}

export default withFormsy(FileInput);
